import { FormEngineController } from './form-engine.controller';
import { FormEngineProps } from './form-engine.model';

export const FormEngine = (props: FormEngineProps) => {
  return <FormEngineController {...props} />;
};

export default FormEngine;
